import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Locations from './components/Locations';
import Reservation from './components/Reservation';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Gallery />
      <Locations />
      <Reservation />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;